// slices/user/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types/User'; // Or your specific Profile type path

type UserStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

interface UserState {
  profile: User | null;
  status: UserStatus;
  error: string | null;
}

const initialState: UserState = {
  profile: null,
  status: 'idle',
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userLoading: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    userReceived: (state, action: PayloadAction<User>) => {
      state.profile = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    userUpdateReceived: (state, action: PayloadAction<Partial<User>>) => {
      // Merge updates into existing profile
      if (state.profile) {
        state.profile = { ...state.profile, ...action.payload };
      } else {
        // Handle case where profile doesn't exist yet if necessary
        // Or ensure profile is always loaded before updates
      }
      state.status = 'succeeded'; // Or keep as is if it was already succeeded
    },
    userFailed: (state, action: PayloadAction<string | null>) => {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to load user profile';
      // state.profile = null; // Optional: Clear profile on failure?
    },
    clearUser: (state) => {
      state.profile = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  // Listen for logout action from authSlice to clear user data
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.profile = null;
      state.status = 'idle';
      state.error = null;
    });
  },
});

export const {
  userLoading,
  userReceived,
  userUpdateReceived,
  userFailed,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;

// Import the logout action from authSlice
import { logout } from '../auth/authSlice';
